import styled from 'styled-components';

export const StyledHelpBox = styled.div`
  margin-bottom: 0.25rem;
  padding: 0.375rem 0.5rem;
  background: var(--gray-100);
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: ${({ theme }) => theme.radii.sm};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.5;
`;

export const StyledExpressionCode = styled.code`
  font-family: var(--font-mono);
  background: var(--gray-200);
  padding: 0 3px;
  border-radius: ${({ theme }) => theme.radii.sm};
`;
